export default "__VITE_ASSET__COVNJnOp__"